<script>
import FormInput from "@/components/molecules/form-input";
import Form from "@/components/molecules/form";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";
import FormError from "@/components/molecules/form/form-error";
import { required } from "@vuelidate/validators";

export default {
  name: "RenameCardForm",
  components: {
    FormInput,
    LazyImage,
    Button,
    Titre,
    FormError,
    Form
  },
  props: {
    carte: {
      type: Object,
      required: false,
      default: () => {}
    },
    error: {
      type: String,
      required: false,
      default: null
    },
    ...formValidationProps()
  },
  emits: ["renameCarte"],
  setup(props) {
    const { v$ } = useFormValidation(props);
    return { v$ };
  },
  data() {
    return {
      carteLibelle: this.carte.attributes.libelle
    };
  },
  validations: {
    carteLibelle: {
      required
    }
  }
};
</script>

<template>
  <div>
    <Titre
      tag="h1"
      variant="primary"
      size="md"
      class="u-text-center u-mb-md"
    >
      Renommer ma carte bancaire
    </Titre>

    <div class="c-rename-card-form__content">
      <div class="u-flex u-flex-justify-center u-flex-align-center">
        <LazyImage
          :src="carte.attributes.reseau_emeteur_logo"
          width="45"
          height="28"
          alt="cb"
          class="u-flex-shrink-none u-mr-sm"
        />
        <p>
          {{ carte.attributes.reseau_emeteur }} {{ carteBancaireMasque(carte.attributes.num_carte) }}
        </p>
      </div>

      <Form 
        class="u-flex u-flex-column u-flex-align-center u-full-width u-mt-md"
        @submit.prevent="$emit('renameCarte', carteLibelle, carte.attributes.id_alias )"
      >
        <FormInput
          v-model="carteLibelle"
          value="Ma carte perso"
          size="xlg"
          maxlength="22"
        >
          {{ carte.attributes.libelle }}
        </FormInput>
        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-mt-lg"
          :disabled="v$.carteLibelle.$invalid"
          type="submit"
        >
          Valider
        </Button>
        <FormError
          v-if="error"
          class="u-mt-sm"
          :error="error"
        />
      </Form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-rename-card-form__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 32rem;
  width: 100%;
  margin: 0 auto;
}
</style>
